import React, {useEffect, useState} from "react";

import styles from '../../assets/css/user.module.scss';
import {UserApi} from "../../../../utils/UserApi";
import {
    Button,
    Container, Dialog,
    DialogActions, DialogContent,
    DialogTitle,
    Grid,
    Snackbar,
} from "@mui/material";
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded';
import * as yup from "yup";
import {useFormik} from "formik";
import {IMaskInput} from 'react-imask';
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {TextField} from "../../../../components/subComponents/TextField";
import {Alert} from "@mui/lab";
import LoadingButton from "../../../../components/subComponents/LoadingButton";


const MobileMask = React.forwardRef(function TextMaskCustom(props, ref) {
    const {onChange, ...other} = props;
    return (
        <IMaskInput
            {...other}
            mask="(#900) 000-0000"
            definitions={{
                '#': /[0]/,
            }}
            inputRef={ref}
            onAccept={(value) => onChange({target: {name: props.name, value}})}
            overwrite
        />
    );
});
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));


const User = props => {
    const params = useParams();
    const [openUserUpdateDialog, setOpenUserUpdateDialog] = React.useState(false);
    const [openUserPasswordUpdateDialog, setOpenUserPasswordUpdateDialog] = React.useState(false);
    const [openSnackBar1, setOpenSnackBar1] = React.useState(false);
    const [message, setMessage] = useState('');
    const [updatingUser, setUpdatingUser] = useState(false);
    const [updatingPassword, setUpdatingPassword] = useState(false);


    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };
    const handleCloseUpdateProfileDialog = () => {
        setOpenUserUpdateDialog(false);
    };

    const handleOpenUserPasswordUpdateDialog = () => {
        setOpenUserPasswordUpdateDialog(true);
    }
    const handleCloseUserPasswordUpdateDialog = () => {
        setOpenUserPasswordUpdateDialog(false);
    }


    const validationSchema = yup.object({
        mail: yup
            .string('پست الکترونیکی خود را وارد کنید')
            .email('پست الکترونیکی معتبر وارد کنید')
            .required('وارد کردن پست الکترونیکی اجباری ست.'),
        name: yup
            .string('رمز عبور خود را وارد کنید.')
            .required('وارد کردن نام الزامی ست.'),
        phone: yup
            .string('تلفن همراه را وارد کنید.')
            .required('وارد کردن تلفن همراه الزامی ست.')


    });
    const validationSchema2 = yup.object({
        password: yup
            .string("رمز عبور جدید را وارد کنید.")
            .min(8, "طول رمز عبور حداقل باید 8 کارکتر باشد.")
            .required("وارد کردن رمز عبور الزامی ست."),
        passwordConfirmation: yup
            .string("رمز عبور را تکرار کنید.")
            .oneOf([yup.ref('password'), null], 'ورودی ها با یکدیگر یکسان نیستند.')
            .required("تکرار رمز عبور الزامی ست.")
    });
    const navigate = useNavigate();

    const formik2 = useFormik({
        initialValues: {
            password: '', passwordConfirmation: ''

        },
        validationSchema: validationSchema2,
        onSubmit: async (values) => {

            const response = (result) => {
                handleClickSnackBar1('بروزرسانی رمز عبور با موفقیت انجام شد.');
                handleCloseUserPasswordUpdateDialog();
                setUpdatingPassword(false);
                formik2.resetForm();
            }
            const error = (e) => {

            }
            setUpdatingPassword(true);
            let fd = new FormData();
            fd.append("payload", JSON.stringify({password: values.password}));
            await UserApi.updateUserPassword(fd, params.id, response, error);

        },

    })
    const formik = useFormik({
        initialValues: {
            mail: '',
            name: '',
            phone: ''
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {

            const response = async (result) => {
                handleClickSnackBar1('بروزرسانی کاربر با موفقیت انجام شد.');
                await sleep(3000);
                setUpdatingUser(false);
                navigate("/admin/users");
            }
            const error = (e) => {

            }
            setUpdatingUser(true);
            let fd = new FormData();
            fd.append("payload", JSON.stringify({
                name: values.name,
                mail: values.mail,
                phone: values.phone,
                password: values.password
            }));
            await UserApi.updateUser(fd, params.id, response, error);

        },
    });
    const getUser = async () => {
        const response = async (result) => {
            formik.setValues({
                    name: result.data.name,
                    phone: result.data.phone,
                    mail: result.data.mail,
                }
            );

        }
        const error = (e) => {

        }
        await UserApi.getUserById(params.id, response, error);
    }


    useEffect(() => {
        (async () => {
            await getUser();
        })();
    }, []);


    return <div>

        <Container maxWidth={"md"}>
            <Grid container spacing={8}>
                <Grid item xs={12}>
                    <div className={styles.profileTextContainer}>
                        <div>
                            <Button variant="contained" color="primary" endIcon={<VpnKeyRoundedIcon/>}
                                    onClick={(e) => {
                                        handleOpenUserPasswordUpdateDialog();
                                    }}>
                                تغییر رمز عبور
                            </Button>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <form onSubmit={formik.handleSubmit} className={styles.container}>
                        <Grid container>
                            <Grid item xs={12} md={6}>
                                <div className={styles.inputContainer}>
                                    <TextField label="نام" variant="outlined"
                                               value={formik.values.name}
                                               onChange={formik.handleChange}
                                               fullWidth
                                               id="name"
                                               name="name"
                                               error={formik.touched.name && Boolean(formik.errors.name)}
                                               helperText={formik.touched.name && formik.errors.name}
                                               InputLabelProps={{shrink: formik.values.name ? true : false}}
                                    />
                                </div>
                            </Grid>


                            <Grid item xs={12} md={6}>
                                <div className={styles.inputContainer}>

                                    <TextField label="تلفن همراه" variant="outlined"
                                               className={`${styles.ltrTextField}`}

                                               value={formik.values.phone}
                                               onChange={formik.handleChange}
                                               InputProps={{
                                                   inputComponent: MobileMask,
                                               }}
                                               fullWidth
                                               id="phone"
                                               name="phone"
                                               error={formik.touched.phone && Boolean(formik.errors.phone)}
                                               helperText={formik.touched.phone && formik.errors.phone}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <div className={styles.inputContainer}>
                                    <TextField label="پست الکترونیکی" variant="outlined"
                                               value={formik.values.mail}
                                               onChange={formik.handleChange}
                                               fullWidth
                                               id="mail"
                                               name="mail"
                                               error={formik.touched.mail && Boolean(formik.errors.mail)}
                                               helperText={formik.touched.mail && formik.errors.mail}
                                               className={`${styles.ltrTextField}`}
                                               InputLabelProps={{shrink: formik.values.mail ? true : false}}

                                    />
                                </div>
                            </Grid>
                        </Grid>
                        <Button color="error" onClick={() => {
                            navigate(-1);
                        }}>
                            انصراف
                        </Button>

                        <LoadingButton
                            loading={updatingUser}
                            loadingPosition="end"
                            variant={'text'}
                            color="primary"
                            type={"submit"}
                            component="button"

                        >
                            ثبت
                        </LoadingButton>
                    </form>

                </Grid>
            </Grid>

        </Container>


        <Dialog onClose={handleCloseUpdateProfileDialog} aria-labelledby="customized-dialog-title"
                open={openUserUpdateDialog}
                maxWidth={'lg'}
                fullWidth={true}
                className={`${styles.dialog}`}
        >
            <form onSubmit={formik.handleSubmit}>

                <DialogTitle id="customized-dialog-title" onClose={handleCloseUpdateProfileDialog}
                             className={styles.typography1}>
                    مشاهده و بروزرسانی
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container>

                        <Grid item xs={4}>
                            <div className={styles.inputContainer}>
                                <TextField label="نام" variant="outlined"
                                           value={formik.values.name}
                                           onChange={formik.handleChange}
                                           fullWidth
                                           id="name"
                                           name="name"
                                           error={formik.touched.name && Boolean(formik.errors.name)}
                                           helperText={formik.touched.name && formik.errors.name}
                                />
                            </div>

                        </Grid>


                        <Grid item xs={4}>
                            <div className={styles.inputContainer}>

                                <TextField label="تلفن همراه" variant="outlined"
                                           className={`${styles.ltrTextField}`}
                                           value={formik.values.mobile}
                                           onChange={formik.handleChange}
                                           InputProps={{
                                               inputComponent: MobileMask,
                                           }}
                                           fullWidth
                                           id="mobile"
                                           name="mobile"
                                           error={formik.touched.phone && Boolean(formik.errors.mobile)}
                                           helperText={formik.touched.phone && formik.errors.mobile}

                                />
                            </div>
                        </Grid>

                        <Grid item xs={4}>
                            <div className={styles.inputContainer}>
                                <TextField label="پست الکترونیکی" variant="outlined"
                                           value={formik.values.mail}
                                           onChange={formik.handleChange}
                                           fullWidth
                                           id="mail"
                                           name="mail"
                                           error={formik.touched.mail && Boolean(formik.errors.mail)}
                                           helperText={formik.touched.mail && formik.errors.mail}
                                />
                            </div>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseUpdateProfileDialog} color="secondary">
                        انصراف
                    </Button>

                    <LoadingButton
                        loading={updatingUser}
                        loadingPosition="end"
                        variant={'text'}
                        color="primary"
                        type={"submit"}
                        component="button"

                    >
                        ثبت تغییرات
                    </LoadingButton>
                </DialogActions>
            </form>
        </Dialog>
        <Dialog open={openUserPasswordUpdateDialog} onClose={handleCloseUserPasswordUpdateDialog}
                maxWidth={'sm'}
                fullWidth
                className={`${styles.dialog}`}
        >
            <form onSubmit={formik2.handleSubmit}>

                <DialogTitle id="customized-dialog-title" onClose={handleCloseUpdateProfileDialog}
                             className={styles.typography1}>
                    تغییر رمز عبور
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container>
                        <Grid item xs={12}>
                            <div className={styles.inputContainer}>

                                <TextField
                                    fullWidth
                                    id="password"
                                    name="password"
                                    label="رمز عبور"
                                    type="password"
                                    value={formik2.values.password}
                                    onChange={formik2.handleChange}
                                    error={formik2.touched.password && Boolean(formik2.errors.password)}
                                    helperText={formik2.touched.password && formik2.errors.password}
                                    variant="outlined"
                                    className={styles.textField}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={styles.inputContainer}>

                                <TextField
                                    fullWidth
                                    id="passwordConfirmation"
                                    name="passwordConfirmation"
                                    label="رمز عبور"
                                    type="password"
                                    value={formik2.values.passwordConfirmation}
                                    onChange={formik2.handleChange}
                                    error={formik2.touched.passwordConfirmation && Boolean(formik2.errors.passwordConfirmation)}
                                    helperText={formik2.touched.passwordConfirmation && formik2.errors.passwordConfirmation}
                                    variant="outlined"
                                    className={styles.textField}
                                />
                            </div>
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseUserPasswordUpdateDialog} color="secondary">
                        انصراف
                    </Button>
                    <LoadingButton
                        loading={updatingPassword}
                        loadingPosition="end"
                        variant={'text'}
                        color="primary"
                        type={"submit"}
                        component="button"

                    >
                        ثبت تغییرات
                    </LoadingButton>
                </DialogActions>
            </form>

        </Dialog>


        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert onClose={handleCloseSnackBar1} severity="info"
                   action={null

                   }
                   className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>
    </div>
};

export default User;
